import { render, staticRenderFns } from "./CandidateChecklist.vue?vue&type=template&id=0b4be20a&"
import script from "./CandidateChecklist.vue?vue&type=script&lang=js&"
export * from "./CandidateChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports